<template>
  <div class="mod">
    <transition name="modal">
      <div v-if="visible">
        <div class="overlay" @click.self="hideModal()">
          <div class="modal">
            <header class="modtop">
              <span></span>
              <span class="close-button" @click.self="hideModal()">
                    X
                </span>
              <span class="top-title">{{ modalTitle }}</span>
            </header>
            <div class="modal-dialog" style="overflow-y: auto; max-height:95%; " >
              <span class="modal-body">
                <component :is="component"></component>
              </span>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import Vue from 'vue';
import { mapState, mapMutations } from 'vuex';

export default {
  name: "ModalWindow",
  props: [],
  data () {
    return {
      component: null,
    }
  },
  computed: {
    ...mapState({
      visible: 'modalVisible',
      modalComponent: 'modalComponent',
      modalTitle: 'modalTitle',
    }),
  },
  methods: {
    ...mapMutations(['hideModal']),
  },
  created() {
    const escapeHandler = (e) => {
      if (e.key === 'Escape' && this.visible) {
        this.hideModal();
      }
    };

    document.addEventListener('keydown', escapeHandler);
    this.$once('hook:destroyed', () => {
      document.removeEventListener('keydown', escapeHandler);
    });
  },
  watch: {
    modalComponent(componentName) {
      console.log('Modal component changed!', componentName);
      if (!componentName) return;

      Vue.component(componentName, () => import(`./${componentName}`));

      this.component = componentName;
    },
  },
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/ModalWindow.vue